//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { store } from "./store";

import PanelFilterGroup from './PanelFilterGroup.vue';
import FilterCheckboxGroup from './FilterCheckboxGroup.vue';

export default {
  name: 'PanelFilter',
  components: {
    PanelFilterGroup,
    FilterCheckboxGroup,
  },
  data() {
    return {
      search: '',
      result: '',
    }
  },
  watch: {
    search() {
      this.result = store.getFilterValues('post_id')
    },
  },
  methods: {
    searchHandler() {
    
      store.resetFilterValues()
      
      if(this.search != '') {
        store.searchByString(this.search)
      }
      this.$root.$emit('updateGoogleMap')
    },
    emitGlobalClickEvent() {
      // clear the search box
      this.search=''

      store.resetFilterValues()
      this.$root.$emit('clearCheckboxes')
      this.$root.$emit('updateGoogleMap')
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/PanelFilter.vue